import React from 'react';
import { Location } from '../../types/location';
import styles from '../../styles/shared/CardGrid.module.css';

interface LocationCardProps {
  location: Location;
  onEdit: (location: Location) => void;
  onDelete?: (locationId: number) => void;
  onViewSubLocations?: (locationId: number) => void;
}

const LocationCard: React.FC<LocationCardProps> = ({ location, onEdit, onDelete, onViewSubLocations }) => {
  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <div className={styles.placeholderImage}>
          <span>📍</span>
        </div>
      </div>
      
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle} title={location.location_name}>{location.location_name}</h3>
        {location.long_lat && (
          <p className={styles.cardDescription} title={`Coordinates: ${location.long_lat}`}>Coordinates: {location.long_lat}</p>
        )}
        
        <div className={styles.cardActions}>
          {onViewSubLocations && (
            <button 
              onClick={() => onViewSubLocations(location.id)} 
              className={`${styles.cardActionButton} ${styles.cardViewButton}`}
              title="View SubLocations"
            >
              View
            </button>
          )}
          <button 
            onClick={() => onEdit(location)} 
            className={`${styles.cardActionButton} ${styles.cardEditButton}`}
            title="Edit Location"
          >
            Edit
          </button>
          {onDelete && (
            <button 
              onClick={() => onDelete(location.id)} 
              className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
              title="Delete Location"
            >
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocationCard;
